import React from 'react';
import { getParametersFromUrl } from '../../../../utils/url-utils/urlUtils';
import { Connect, PropsFromRedux } from './SearchResultDecisionsContainer';
import { SearchResultDecision } from './SearchResultDecision';
import { SearchDecision } from '../../../../decision/decision.types';
import { SearchRestriction } from '../../search-restriction/SearchRestriction';
import { withUser } from '../../../../user/UserContext';
import { UserContextType } from '../../../../user/user.types';
import { FoldersDropdownProvider } from '../../../../folders/dropdown/FoldersDropdownContext';

type Props = PropsFromRedux &
  UserContextType & {
    decisions: Array<SearchDecision>;
  };

export class RawSearchResultDecisions extends React.Component<Props> {
  position: number | null = null;

  constructor(props: Props) {
    super(props);
    this.storedDecisions = [];
    const urlParams = getParametersFromUrl(window.location.search);
    this.position = urlParams.position
      ? parseInt(urlParams.position, 10)
      : null;
  }

  componentDidMount() {
    const { decisions } = this.props;

    this.updateStore(decisions);
  }

  componentDidUpdate() {
    this.updateStore(this.props.decisions);
  }

  updateStore = (decisions: Array<SearchDecision>) => {
    const newDecisions = decisions.filter(
      (decision) => !this.storedDecisions.includes(decision.docId),
    );

    const folders = newDecisions.reduce<{ folderKey: string; title: string }[]>(
      (acc, decision) => acc.concat(decision.inFolders),
      [],
    );

    if (folders.length) {
      this.props.updateFolders(folders);
    }
    const decisionsFolders = newDecisions.reduce<{ [s: string]: string[] }>(
      (acc, decision) => {
        acc[decision.docId] = decision.inFolders.map(
          (folder) => folder.folderKey,
        );
        return acc;
      },
      {},
    );

    this.props.updateDecisionsFolders(decisionsFolders);

    this.storedDecisions = this.storedDecisions.concat(
      Object.keys(decisionsFolders),
    );
  };

  storedDecisions: Array<string>;

  render() {
    const { decisions, loggedIn, isSearchLoading } = this.props;
    const showRestriction = !isSearchLoading && !loggedIn;
    return (
      <>
        {decisions.map((decision, index, array) => (
          <div key={decision.docId} data-test-id="search-decision-card">
            <FoldersDropdownProvider>
              <SearchResultDecision
                decision={decision}
                index={index}
                shouldScroll={this.position === index + 1}
                isLast={index === array.length - 1}
              />
            </FoldersDropdownProvider>
          </div>
        ))}
        {showRestriction && <SearchRestriction />}
      </>
    );
  }
}

export const SearchResultDecisions = Connect(
  withUser(RawSearchResultDecisions),
);
